import "core-js/modules/es6.function.name.js";
import datadog from '@nerdwallet/datadog';
import { getLogger } from '@nerdwallet/logging';
var logger = getLogger('nwjs-analytics');
var LOG_LEVELS = {
  debug: 1,
  info: 2,
  warn: 3,
  error: 4,
  none: 5
};

var getLogLevel = function getLogLevel(appConfig) {
  var _appConfig$NWJS_ANALY, _appConfig$NWJS_ANALY2;

  return (_appConfig$NWJS_ANALY = (_appConfig$NWJS_ANALY2 = appConfig.NWJS_ANALYTICS) === null || _appConfig$NWJS_ANALY2 === void 0 ? void 0 : _appConfig$NWJS_ANALY2.LOG_LEVEL) !== null && _appConfig$NWJS_ANALY !== void 0 ? _appConfig$NWJS_ANALY : 'error';
};
/**
 * In development/production environments, handles and logs an error.
 * In a test environment, throws the error to ensure that the test fails.
 */


export var defaultOnError = function defaultOnError(appConfig) {
  logger.setLoggingLevel(getLogLevel(appConfig));
  return function (err) {
    logger.error('An error occurred while sending analytics events', err);

    if (process.env.NODE_ENV === 'test') {
      // Throw when running tests so the test fails
      throw err;
    } // keep track of error counts in datadog. this is a no-op on clients.


    datadog.increment('node.nwjs_analytics.errors', 1, {
      tags: {
        exception: err.code || err.name || err.message
      }
    });
  };
};
/**
 * Will be invoked every time transport occurs with an array of events and
 * the results of sending each one.
 */

export var defaultOnTransportResults = function defaultOnTransportResults(appConfig) {
  if (process.env.NODE_ENV === 'test') {
    // Don't log during tests to avoid spamming the console
    return function () {};
  }

  var logLevel = getLogLevel(appConfig);
  logger.setLoggingLevel(logLevel);
  return function (_ref) {
    var events = _ref.events,
        results = _ref.results;
    results.forEach(function (result, index) {
      var originalEvent = events[index];
      var succeeded = result.success;
      if (succeeded && LOG_LEVELS[logLevel] > LOG_LEVELS.info) return;

      if (typeof document === 'undefined') {
        // We're running in a server context; don't use fancy console.log
        // formatting features.
        if (!succeeded) {
          logger.error('Failed to send analytics event', originalEvent, result.error);
        } else if (LOG_LEVELS[logLevel] >= LOG_LEVELS.info) {
          logger.info('Successfully sent analytics event', originalEvent);
        }

        return;
      } // If we're running on the client, we can use formatting and
      // collapsible groups to make logs prettier. We only want to
      // show these logs when info level is turned on.


      if (LOG_LEVELS[logLevel] >= LOG_LEVELS.info) {
        var _originalEvent$payloa, _console;

        var parts = [];
        var formattingParts = [];
        parts.push("%cevent %c".concat(String(originalEvent.eventType)));
        formattingParts.push('color: gray; font-weight: lighter;', 'font-weight: bold;');
        var entityName = (_originalEvent$payloa = originalEvent.payload) === null || _originalEvent$payloa === void 0 ? void 0 : _originalEvent$payloa.entity_name;

        if (entityName) {
          parts.push("%c".concat(entityName));
          formattingParts.push('font-weight: lighter; font-style: italic;');
        }

        if (succeeded) {
          parts.push('%csuccess');
          formattingParts.push('color: green');
        } else {
          parts.push('%cerror');
          formattingParts.push('color: red');
        }
        /* eslint-disable no-console */


        (_console = console).groupCollapsed.apply(_console, [parts.join(' ')].concat(formattingParts));

        console.log('%cevent', 'font-weight: bold; color: #03A9F4;', originalEvent);

        if (!succeeded) {
          console.log('%cerror', 'font-weight: bold; color: red;', result.error);
        }

        console.groupEnd();
        /* eslint-enable no-console */
      }
    });
  };
};